import { EmailChannel, MessageType, MESSAGE_MEDIUMS } from '../types';

export const mockMailgunBoundChannel: EmailChannel = {
  id: 184,
  createdAt: 1649084127159,
  updatedAt: 1649084127159,
  projectId: 1,
  creatorUserId: 'jane.doe@iterable.com',
  name: 'Email Marketing Channel',
  channelType: 'Marketing',
  messageMedium: MESSAGE_MEDIUMS.EMAIL,
  espBindings: [
    {
      espAccountId: 649,
      trafficPercentage: 100,
    },
  ],
};

export const mockCustomEmailBoundChannel: EmailChannel = {
  id: 184,
  createdAt: 1649084127159,
  updatedAt: 1649084127159,
  projectId: 1,
  creatorUserId: 'sam.iam@email.com',
  name: 'Custom Email Channel',
  channelType: 'Transactional',
  messageMedium: MESSAGE_MEDIUMS.EMAIL,
  espBindings: [
    {
      espAccountId: 378,
      trafficPercentage: 100,
    },
  ],
};

export const mockSmsBoundChannel: EmailChannel = {
  id: 192,
  createdAt: 1649084127159,
  updatedAt: 1649084127159,
  projectId: 1,
  creatorUserId: 'joe.shmoe@iterable.com',
  name: 'SMS Marketing Channel',
  channelType: 'Marketing',
  messageMedium: MESSAGE_MEDIUMS.SMS,
  espBindings: [
    {
      espAccountId: 676,
      trafficPercentage: 40,
    },
    {
      espAccountId: 789,
      trafficPercentage: 60,
    },
  ],
};

export const mockEmailChannel = mockMailgunBoundChannel;

export const mockChannels = [
  mockMailgunBoundChannel,
  mockSmsBoundChannel,
  mockCustomEmailBoundChannel,
];

export const mockMessageTypes = [
  {
    id: 11,
    createdAt: 1649098433457,
    updatedAt: 1649098433457,
    projectId: 1,
    name: 'Another Message Type',
    messageChannelId: 192,
    subscriptionPolicy: 'OptOut',
  },
  {
    id: 7357, // TEST
    createdAt: 1649098433457,
    updatedAt: 1649098433457,
    projectId: 1,
    name: 'Telnyx Message Type',
    messageChannelId: 192,
    subscriptionPolicy: 'OptOut',
  },
];

export const mockMessageType: MessageType = mockMessageTypes[0];
